import React, { useMemo } from 'react';
import {
  GenericSearchEdge,
  HistoryAction,
  HistoryType,
  RulesOfCourtSearchDocument,
} from '__generated__/graphql';
import { CourtRulesResult } from 'pages/rules/CourtRulesResult';
import { TypedSearchResults } from '../TypedSearchResults';
import { EmptyResults } from '../EmptyResults';
import styled from 'styled-components';
import TitledPage from 'components/common/TitledPage';
import {
  StyledSearchContent,
  StyledSearchHeader,
  StyledSearchResults,
} from '../SearchStyles';
import { SearchFilters, StyledSearchWithin } from '../SearchFilters';
import { FilterChips } from '../FilterChips';
import useSearchVariables from '../useSearchVariables';
import { SearchWithin } from '../SearchWithin';
import { useAssetAccess } from 'components/asset-access';
import { TrackHistory } from 'hooks/useHistory';

export function RulesSearch() {
  const searchVariables = useSearchVariables();
  const assetAccess = useAssetAccess();

  const variables = React.useMemo(() => {
    return {
      ...searchVariables,
      optionFilters: [
        'titleid_CRC',
        ...(assetAccess?.hasLocalRulesOfCourt
          ? [
              'titleid_LRC_LA',
              'titleid_LRC_SD',
              'titleid_LRC_OR',
              'titleid_LRC_FR',
              'titleid_LRC_SM',
              'titleid_LRC_SAC',
              'titleid_LRC_KR',
              'titleid_LRC_ST',
              'titleid_LRC_CC',
              'titleid_LRC_SB',
              'titleid_LRC_AL',
              'titleid_LRC_TU',
              'titleid_LRC_RI',
              'titleid_LRC_SF',
              'titleid_LRC_VE',
              'titleid_LRC_SBA',
              'titleid_LRC_SOL',
              'titleid_LRC_SON',
              'titleid_LRC_SJ',
              'titleid_LRC_SC',
            ]
          : []),
      ].join(','),
    };
  }, [assetAccess, searchVariables]);

  return (
    <TitledPage title="Search Rules of Court">
      <TrackHistory
        text={variables.query}
        type={HistoryType.StatuteRule}
        action={HistoryAction.Search}
        subtype="SEARCH_STATUTE_RULE"
      />

      <SearchFilters queryVariables={['textFilters', 'optionFilters']}>
        <RulesFilters />
      </SearchFilters>

      <StyledSearchContent>
        <StyledSearchHeader>
          <div>
            <StyledSearchWithin>{<SearchWithin />}</StyledSearchWithin>
          </div>
          <div>
            <FilterChips
              filters={{
                Code: 'code_',
              }}
            />
          </div>
        </StyledSearchHeader>

        <StyledCourtRulesResults>
          <TypedSearchResults
            resultTitle="Rules of Court Result"
            query={RulesOfCourtSearchDocument}
            variables={variables}
            emptyResults={<EmptyResults />}
          >
            {result => (
              <StyledCourtRulesResult
                key={(result as GenericSearchEdge)?.node!.documentId}
                result={result as GenericSearchEdge}
              />
            )}
          </TypedSearchResults>
        </StyledCourtRulesResults>
      </StyledSearchContent>
    </TitledPage>
  );
}

const StyledCourtRulesResults = styled(StyledSearchResults)`
  padding-top: 38px;
`;

const StyledCourtRulesResult = styled(CourtRulesResult)`
  padding: 0;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0px;
  & + & {
    margin-top: 36px;
  }
`;

StyledCourtRulesResult.displayName = 'StyledCourtRulesResult';

function RulesFilters() {
  return <></>;
}
